import { useEffect, useRef, useState } from 'react';
import { socket } from './socket';

/** Mantiene al componente suscrito a una sala mientras está montado. */
export function useRoom(room: string | null | undefined): void {
  useEffect(() => {
    if (!room) return;
    return socket.join(room);
  }, [room]);
}

/**
 * Escucha un tipo de evento del servidor.
 * El manejador se guarda en una referencia para que cambiarlo en cada render
 * no obligue a resuscribirse.
 */
export function useSocketEvent<T = unknown>(
  type: string,
  handler: (data: T, room?: string) => void,
): void {
  const ref = useRef(handler);
  ref.current = handler;

  useEffect(() => {
    return socket.on(type, (data, room) => ref.current(data as T, room));
  }, [type]);
}

/** Estado de la conexión, para mostrar el aviso de «reconectando». */
export function useSocketStatus(): 'connecting' | 'open' | 'closed' {
  const [status, setStatus] = useState(socket.status);

  useEffect(() => {
    return socket.on('status', (value) => setStatus(value as typeof status));
  }, []);

  return status;
}
